// extracted by mini-css-extract-plugin
export default {"container":"Promotion_container__EDVlN","title":"Promotion_title__j1MBk"};